import { Form, Row } from "react-bootstrap";
import {
  Button,
  ButtonsContainer,
  Container,
  DatePickerContainer,
  FormContainer,
  Header,
  InputContainer,
  TextoHeader,
} from "./style";
import { Controller, useForm } from "react-hook-form";
import { DropdownSelect, IOptions } from "components/DropdownSelect";
import { yupResolver } from "@hookform/resolvers/yup";
import { CustomDatePicker } from "components/DatePicker";
import { useState } from "react";
import { CustomInputModal } from "components/CustomInputModal";
import { useBloqueioAdministrativo } from "features/core/pages/Veiculo/pages/BloqueioAdministrativo/hooks/useBloqueioAdministrativo";
import { FiltrosItensBloqueioAdministrativoSchema } from "../../validate/FiltrosItensBloqueioAdministrativo";
import { IFiltroItensBloqueioAdministrativo } from "../../../../interfaces/IFiltroItensBloqueioAdministrativo";
import { IListarItensBloqueio } from "../../../../interfaces/IListarItensBloqueio";

interface IProps {
  submitForm: (dados: IFiltroItensBloqueioAdministrativo) => void;
  setRowsSelected: (itens: IListarItensBloqueio[]) => void;
  empresasOptions: IOptions[];
  cnpjsOptions: IOptions[];
  listarCnpjsIntegracaoFrotista: (idEmpresa: number) => void;
}

export function FiltroItensBloqueioAdministrativo({
  submitForm,
  setRowsSelected,
  empresasOptions,
  cnpjsOptions,
  listarCnpjsIntegracaoFrotista,
}: IProps) {
  const { handleSubmit, control, setValue } = useForm({
    resolver: yupResolver(FiltrosItensBloqueioAdministrativoSchema),
  });

  const [inicioDataCadastro, setInicioDataCadastro] = useState<Date>();
  const [fimDataCadastro, setFimDataCadastro] = useState<Date>();
  const onChangeDataCadastro = (dates: any) => {
    const [start, end] = dates;
    setInicioDataCadastro(start);
    setFimDataCadastro(end);
  };

  const { validarVeiculos, validarProcessos } = useBloqueioAdministrativo();

  const onClickLimpar = () => {
    setValue("idsLotes", null);
    setValue("idsProcessos", null);
    setValue("dadosVeiculos", null);
    setValue("idEmpresa", null);
    setValue("cnpj", null);
    setValue("situacao", null);
    setValue("statusSolicitacao", null);
    setValue("dataCriacaoLote", [null, null]);
    setFimDataCadastro(undefined);
    setInicioDataCadastro(undefined);
    listarCnpjsIntegracaoFrotista(0);
    submitForm({});
    setRowsSelected([]);
  };

  return (
    <Container>
      <Header>
        <TextoHeader>Filtros</TextoHeader>
      </Header>
      <hr></hr>
      <FormContainer>
        <Form
          noValidate
          onSubmit={handleSubmit((dados: IFiltroItensBloqueioAdministrativo) =>
            submitForm(dados),
          )}
        >
          <Row className="mb-4">
            <InputContainer lg="3">
              <Form.Group>
                <Form.Label>ID Processo</Form.Label>
                <Controller
                  control={control}
                  name="idsProcessos"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque pelo processo"
                      onConfirm={onChange}
                      onClickOk={validarProcessos}
                      validar={true}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou copie e cole os IDs dos processos que deseja buscar e tecle ENTER"
                      labelItem="ID Processo"
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>
            <InputContainer lg="3">
              <Form.Group>
                <Form.Label>Veículo</Form.Label>
                <Controller
                  control={control}
                  name="dadosVeiculos"
                  defaultValue={[]}
                  render={({ field: { onChange, value } }) => (
                    <CustomInputModal
                      label="Filtrar em massa"
                      value={value ?? []}
                      placeholder="Busque por placa, chassi ou renavam"
                      onConfirm={onChange}
                      onClickOk={validarVeiculos}
                      validar={true}
                      style={{ width: "100%" }}
                      placeholderModal="Digite ou copie e cole placa, chassi ou renavam dos veículos que deseja buscar e tecle ENTER"
                      labelItem="Veículos"
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>
            <InputContainer lg="3">
              <Form.Group>
                <Form.Label>Situação</Form.Label>
                <Controller
                  control={control}
                  name="situacao"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      title=""
                      options={[
                        { label: "Bloqueado", value: "BLOQUEADO" },
                        { label: "Desbloqueado", value: "DESBLOQUEADO" },
                      ]}
                      selectedValue={value}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>
            <InputContainer lg="3">
              <Form.Group>
                <Form.Label>Status solicitação</Form.Label>
                <Controller
                  control={control}
                  name="statusSolicitacao"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      title=""
                      options={[
                        { value: "CONCLUIDO", label: "Concluído" },
                        { value: "PROCESSANDO", label: "Processando" },
                        { value: "ERRO", label: "Erro" },
                      ]}
                      selectedValue={value}
                      onSelect={onChange}
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>
          </Row>
          <Row>
            <InputContainer lg="3">
              <Form.Group>
                <Form.Label>Empresa</Form.Label>
                <Controller
                  control={control}
                  name="idEmpresa"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      options={empresasOptions}
                      title=""
                      selectedValue={value}
                      onSelect={(valor) => {
                        listarCnpjsIntegracaoFrotista(valor);
                        onChange(valor);
                        setValue("cnpj", null);
                      }}
                      searchable
                      required
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>
            <InputContainer lg="3">
              <Form.Group>
                <Form.Label>CNPJ</Form.Label>
                <Controller
                  control={control}
                  name="cnpj"
                  render={({ field: { onChange, value } }) => (
                    <DropdownSelect
                      title=""
                      options={cnpjsOptions}
                      selectedValue={value}
                      onSelect={onChange}
                      disabled={!cnpjsOptions.length}
                    />
                  )}
                />
              </Form.Group>
            </InputContainer>
            <InputContainer lg="3">
              <Form.Group>
                <Controller
                  control={control}
                  name="dataCriacaoLote"
                  render={({ field: { onChange } }) => (
                    <DatePickerContainer>
                      <span>Período</span>
                      <CustomDatePicker
                        selected={inicioDataCadastro}
                        onChange={(update) => {
                          onChange(update);
                          onChangeDataCadastro(update);
                        }}
                        startDate={inicioDataCadastro}
                        endDate={fimDataCadastro}
                        rangeSelect={true}
                      />
                    </DatePickerContainer>
                  )}
                />
              </Form.Group>
            </InputContainer>
            <InputContainer lg="3">
              <Form.Group>
                <ButtonsContainer>
                  <Button
                    type="reset"
                    outline
                    variante="primary"
                    style={{ marginRight: "8px", width: "76px" }}
                    onClick={onClickLimpar}
                  >
                    Limpar
                  </Button>
                  <Button type="submit" style={{ width: "76px" }}>
                    Buscar
                  </Button>
                </ButtonsContainer>
              </Form.Group>
            </InputContainer>
          </Row>
        </Form>
      </FormContainer>
    </Container>
  );
}
